import React from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import NotificationToast from './NotificationToast'

// Tres a la vez y no diez. Cinco menciones seguidas (alguien contestando un hilo
// mientras te nombra) taparían media pantalla, y a partir del cuarto aviso nadie
// los lee: los cierra todos de un manotazo.
const MAX_VISIBLES = 3

/**
 * Pila de avisos efímeros, arriba a la derecha.
 *
 * Va en un portal sobre el body y no dentro del árbol del layout porque el
 * provider está adentro del Router, y cualquier contenedor con overflow o
 * transform en el medio recortaría los avisos o los sacaría de lugar.
 */
const NotificationToaster = ({ toasts, onClose, onOpen }) => {
	const { t } = useTranslation()

	if (typeof document === 'undefined' || !toasts.length) {
		return null
	}

	// Los más nuevos arriba, que es donde mira el ojo cuando algo aparece.
	const enPantalla = toasts.slice(-MAX_VISIBLES).reverse()
	const sobrantes = toasts.length - enPantalla.length

	return createPortal(
		<>
			<style>{`
				@keyframes storehub-toast-drain { to { transform: scaleX(0) } }
				@keyframes storehub-toast-in {
					from { opacity: 0; transform: translateX(16px) scale(.98) }
					to { opacity: 1; transform: none }
				}
				@media (prefers-reduced-motion: reduce) {
					.storehub-toast-item { animation: none !important }
				}
			`}</style>

			{/* pointer-events-none en el contenedor y auto en cada aviso: la
			    columna ocupa toda la altura y sin esto se comería los clicks de
			    la app en una franja vertical entera. */}
			<div
				className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 w-[22rem] max-w-[calc(100vw-2rem)] pointer-events-none"
			>
				{enPantalla.map((notif) => (
					<div
						key={notif.id}
						className="storehub-toast-item pointer-events-auto"
						style={{ animation: 'storehub-toast-in .22s cubic-bezier(.2,.8,.3,1)' }}
					>
						<NotificationToast
							notification={notif}
							onClose={onClose}
							onOpen={onOpen}
						/>
					</div>
				))}

				{sobrantes > 0 && (
					<div className="pointer-events-none text-center text-xs font-semibold py-1.5 rounded-lg
						bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700
						text-gray-500 dark:text-gray-400 shadow-lg">
						{sobrantes === 1
							? t('one_more_notification', '1 aviso más')
							: t('n_more_notifications', `${sobrantes} avisos más`)}
					</div>
				)}
			</div>
		</>,
		document.body
	)
}

export default NotificationToaster
